import React, { useEffect, useState } from 'react';
import { getStripComponentFromStripData } from '../../services/pursuit/stripsService';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';
export default function StripModal(props) {
    var fields = props.fields, children = props.children, isFlyoverSite = props.isFlyoverSite;
    var _a = useState(false), isOpen = _a[0], setIsOpen = _a[1];
    var toggleModal = function () { return setIsOpen(!isOpen); };
    useEffect(function () {
        // Event listener to open the modal
        var openModalListener = function () { return setIsOpen(true); };
        // Add event listeners
        window.addEventListener('openModal' + fields.modalTriggerID, openModalListener);
        // Cleanup event listeners on unmount
        return function () {
            window.removeEventListener('openModal' + fields.modalTriggerID, openModalListener);
        };
    }, []);
    return (React.createElement(Modal, { isOpen: isOpen, toggle: toggleModal },
        React.createElement(ModalHeader, { toggle: toggleModal }),
        React.createElement(ModalBody, null,
            React.createElement("div", { className: "d-flex" }, children && children.map(function (child) { return React.createElement("div", { className: "row" }, getStripComponentFromStripData(children[0], { labels: props.labels, isFlyoverSite: isFlyoverSite })); })))));
}
